var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 4.00051C4.58171 4.00051 1 6.23818 1 8.99967C1 11.7612 4.58171 14 9 14C13.4183 14 17 11.7612 17 8.99967C17 6.23818 13.4183 4.00051 9 4.00051ZM9 4.00051L8.99944 0M16 1.99962L14.3577 5.28728M1.99944 1.99962L3.64173 5.28728M10.9996 8.99966C11.0164 9.82904 10.5398 10.5863 9.79395 10.9156C9.04808 11.2449 8.18118 11.0807 7.60062 10.5003C7.02006 9.9198 6.84128 9.03844 7.14827 8.27036C7.45527 7.50227 8.18701 7.00017 8.99964 6.99999C9.52463 6.99439 10.0303 7.20193 10.4054 7.57695C10.7804 7.95197 10.9942 8.46373 10.9996 8.99966Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
};
export default SvgEye;